var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.99935 2.29102C5.74215 2.29102 2.29102 5.74215 2.29102 9.99935C2.29102 14.2565 5.74215 17.7077 9.99935 17.7077C14.2565 17.7077 17.7077 14.2565 17.7077 9.99935C17.7077 5.74215 14.2565 2.29102 9.99935 2.29102ZM1.04102 9.99935C1.04102 5.0518 5.0518 1.04102 9.99935 1.04102C14.9469 1.04102 18.9577 5.0518 18.9577 9.99935C18.9577 14.9469 14.9469 18.9577 9.99935 18.9577C5.0518 18.9577 1.04102 14.9469 1.04102 9.99935ZM9.99935 6.04102C10.3445 6.04102 10.6243 6.32084 10.6243 6.66602V9.99935C10.6243 10.3445 10.3445 10.6243 9.99935 10.6243C9.65417 10.6243 9.37435 10.3445 9.37435 9.99935V6.66602C9.37435 6.32084 9.65417 6.04102 9.99935 6.04102ZM9.99935 12.7077C9.65417 12.7077 9.37435 12.9876 9.37435 13.3327C9.37435 13.6779 9.65417 13.9577 9.99935 13.9577H10.0077C10.3529 13.9577 10.6327 13.6779 10.6327 13.3327C10.6327 12.9876 10.3529 12.7077 10.0077 12.7077H9.99935Z",
  fill: "#00538F"
});

function SvgAlertBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBlue);
export default __webpack_public_path__ + "static/media/alert-blue.fd0a6c83.svg";
export { ForwardRef as ReactComponent };